<template>
    <div ref="a4" class="blank-page">
        <template v-for="(page,index) in pages" :key="page">
            <div class="wrapper" :class="{break:index > 0}">
                <div class="sign">
                    <SingleItem />
                </div>
                <div class="sign">
                    <SingleItem />
                </div>
                <div class="sign">
                    <SingleItem />
                </div>
            </div>
        </template>
    </div>
    
</template>

<script>
import { ref } from '@vue/reactivity'
import SingleItem from './components/SingleItem.vue'
import {is_sales_print} from './Scripts/scripts'
import { watch } from '@vue/runtime-core'

export default {
    props:['pages'],
    components:{SingleItem},
    setup(){
        const a4 = ref()
        
        const handle_print = () => {
            var styleElem = document.createElement('style');
            styleElem.type = 'text/css' ;
            var css = `
                @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');
                *{
                    direction:rtl;
                    font-family: 'Rubik', sans-serif;
                    font-weight:normal;
                }
                @media print {
                    .add-icon,.clean-icon,.save-icon{
                        display:none;
                    }
                    .break{
                        page-break-before: always;
                    }
                }
                .blank-page{
                    width:210mm;
                    min-height: 297mm;
                }
                .wrapper{
                    width:210mm;
                    height: 297mm;
                }
                .blank-page .sign{
                    width: 100%;
                    height: calc(100% / 3);
                    border:1px solid black;
                }

                .single-item{
                    width: 100%;
                    height: 100%;
                }

                .single-item-input-texts{
                    position: relative;
                    width: 100%;
                    height: 30%;
                }
                .float-icon{
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 5px;
                    
                }
                .add-icon,.clean-icon{
                    color: var(--success);
                    cursor: pointer;
                    font-size: 50px;
                    user-select: none;
                }
                .clean-icon{
                    color: var(--danger);
                }
                .single-item-input-texts .he,.single-item-input-texts .ru{
                    width: 100%;
                    height: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 25px;
                    text-align: center;
                }
                .single-item-input-texts .ru{
                    font-size: 18px;
                    
                }

                .logo{
                    position: absolute;
                    width: 100px;
                    height: 100%;
                    bottom: 5px;
                    left: 5px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .logo img{
                    width: 100px;
                    height: 30px;
                }

                .single-item-contents{
                    width: 100%;
                    height: 50%;
                    display: flex;
                    font-size: 40px;
                }
                .col{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .col-2{
                    width: 45%;
                    height: 100%;
                }
                .col-1{
                    width: 10%;
                    height: 100%;
                }
                .col.small{
                    font-size: unset; 
                    text-align: center;
                }
                .single-item-footer{
                    position: relative;
                    width: 100%;
                    height: 20%;
                    display: flex;
                }
                .single-item-footer .barcodes,.single-item-footer .grams{
                    width: 50%;
                    height: 100%;
                }
                .single-item-footer .grams{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 30px;
                }
                .single-item-footer .barcodes{
                    display: flex;
                    align-items: center;
                    padding: 0 5px;
                }
            
                [data-slice]{
                    white-space: nowrap; 
                    overflow: hidden;
                    text-overflow: ellipsis;
                    margin-right: 5px;
                }
                [data-fixed]{
                    display: flex;
                    align-items: center;
                }

                .choos-item{
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: var(--main);
                    z-index: 1000;
                }
                .slide-in-top {
                        -webkit-animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
                        animation: slide-in-top 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
                }

                @-webkit-keyframes slide-in-top {
                    0% {
                        -webkit-transform: translateY(-1000px);
                                transform: translateY(-1000px);
                        opacity: 0;
                    }
                    100% {
                        -webkit-transform: translateY(0);
                                transform: translateY(0);
                        opacity: 1;
                    }
                }
                @keyframes slide-in-top {
                    0% {
                        -webkit-transform: translateY(-1000px);
                                transform: translateY(-1000px);
                        opacity: 0;
                    }
                    100% {
                        -webkit-transform: translateY(0);
                                transform: translateY(0);
                        opacity: 1;
                    }
                }

            `
            if(styleElem.styleSheet){
                styleElem.styleSheet.cssText = css;
            }
            else{
                styleElem.appendChild(document.createTextNode(css));
            }
            
            let newWin= window.open('', '', 'height=500, width=500');
            newWin.document.write(a4.value.outerHTML);
            newWin.document.getElementsByTagName('head')[0].appendChild(styleElem);
            newWin.document.close();
            is_sales_print.value = false
            newWin.print();
        }

        watch(is_sales_print,()=>{
            if(is_sales_print.value){
                setTimeout(() => {
                    handle_print()
                }, 500);
            }
        })
        return{
            handle_print,
            a4,
        }
    }
}
</script>

<style scoped>
    .blank-page{
        width: 100%;
        /* height: 100%; */
        min-height: 100%;
        background: #fff;
        padding: 5px;
    }
    .wrapper{
        width: 100%;
        height: 297mm;
    }

    .blank-page .sign{
        width: 100%;
        height: calc(100% / 3);
        border:1px solid black;
    }


</style>